<div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <div class="p-heading-area01">
    <div class="p-heading-area01__title">
      <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'label.numberOfPassengers2' | staticMsg"></h2>
    </div>
    <div class="p-heading-area01__sub-function">
      <asw-button
        id="plan-review-passenger-number-area-open-add-passenger--modal"
        size="xs"
        (click$)="openAddPassengerModal()"
        throttleClick
        [disabled]="!isPlanValid"
        [label]="'label.openAddPassengerModal' | staticMsg"
      ></asw-button>
    </div>
  </div>

  <div class="p-manage-booking">
    <div class="p-manage-booking__item" [ngClass]="{ 'grey-bg': !isPlanValid }">
      <dl class="c-float-list01">
        <div *ngIf="numPerPtc.ADT > 0" class="c-float-list01__item">
          <dt class="c-float-list01__title" [innerHTML]="'label.adult' | staticMsg"></dt>
          <dd class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal">
            {{ numPerPtc.ADT }}
          </dd>
        </div>

        <div *ngIf="numPerPtc.CHD > 0" class="c-float-list01__item">
          <dt class="c-float-list01__title" [innerHTML]="'label.child' | staticMsg"></dt>
          <dd class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal">
            {{ numPerPtc.CHD }}
          </dd>
        </div>

        <div *ngIf="numPerPtc.INF > 0" class="c-float-list01__item">
          <dt class="c-float-list01__title" [innerHTML]="'label.infant' | staticMsg"></dt>
          <dd class="c-float-list01__contents c-float-list01__contents--fs16 c-float-list01__contents--normal">
            {{ numPerPtc.INF }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</div>
